import Link from 'next/link';
import { useRouter } from 'next/router';
import { t } from 'i18next';
// components
import { ExButton } from '@commons/EXComponentsLibrary';
// utils && hooks
import * as gtag from 'utils/gtag';
// styles
import styles from './WIthoutAgreement.module.css';

const WithoutAgreement = () => {
    const { query } = useRouter();
    const [text, subText] = t('listAgreements.placeholder.subTitle').split(',');

    return (
        <div className={styles['wrapper']}>
            <svg xmlns="http://www.w3.org/2000/svg" width="142" height="141" viewBox="0 0 142 141" fill="none">
                <path
                    d="M84.4072 1.00338V19.7922C84.4072 20.5818 83.5427 28.4777 94.7815 28.4777H113.304M107.29 127.703H18.7507C15.3783 127.703 12.6445 124.969 12.6445 121.597V7.10616C12.6445 3.73382 15.3783 1 18.7507 1H84.2041C85.7929 1 87.3191 1.61927 88.4588 2.72634L111.545 25.1526C112.728 26.3024 113.396 27.8823 113.396 29.5324V121.597C113.396 124.969 110.662 127.703 107.29 127.703Z"
                    stroke="#C1D0E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M29.4365 34.5837H62.9896"
                    stroke="#C1D0E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M29.4365 48.7676H95.2573"
                    stroke="#C1D0E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M29.4365 61.1775H95.5795"
                    stroke="#C1D0E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-dasharray="4 4"
                />
                <path
                    d="M124.625 30.1921H133.536"
                    stroke="#C1D0E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M129.079 34.6667V25.7209"
                    stroke="#C1D0E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M118.727 12.6641L124.263 7.1062"
                    stroke="#C1D0E3"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M124.263 12.6641L118.727 7.1062"
                    stroke="#C1D0E3"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M135.918 21.0536C138.623 21.0536 140.817 18.8517 140.817 16.1354C140.817 13.4192 138.623 11.2173 135.918 11.2173C133.212 11.2173 131.019 13.4192 131.019 16.1354C131.019 18.8517 133.212 21.0536 135.918 21.0536Z"
                    stroke="#C1D0E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M13.396 137.651H18.0124"
                    stroke="#C1D0E3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M15.7021 139.966V135.335"
                    stroke="#C1D0E3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M4.05119 134.987C5.63492 134.987 6.91879 133.698 6.91879 132.108C6.91879 130.518 5.63492 129.229 4.05119 129.229C2.46746 129.229 1.18359 130.518 1.18359 132.108C1.18359 133.698 2.46746 134.987 4.05119 134.987Z"
                    stroke="#C1D0E3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M54 114C55.665 115 65.9882 111 67.9862 109C69.9842 107 71.8852 103.224 70.9831 96C69.9842 88 63.99 89 62.991 91C61.992 93 61.992 97 62.991 99C63.99 101 67.9862 104 71.9823 105C75.9783 106 74.9793 102 77.9763 102C80.9734 102 79.9744 106 81.9724 106C83.9704 106 82.9714 101 85.9685 101C87.9665 101 87.9665 109 89.9645 106C91.5629 103.6 90.6305 100.333 90.9635 99L96 84V117"
                    stroke="#C1D0E3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-dasharray="2 2"
                />
            </svg>
            <div className={styles['wrapper-footer']}>
                <div className={styles['wrapper-text']}>
                    <p className={styles['text']}>{t('listAgreements.placeholder.title')}</p>
                    <p className={styles['subtext']}>
                        {text}<br />{subText}
                    </p>
                </div>
                <div className={styles['create-agreement-button']}>
                    <Link
                        href={`/${query?.clientId}/settings/trade-agreements/create`}
                        onClick={() => {
                            // Add gtag event
                            gtag.event({
                                action: 'click',
                                category: 'config__commercial-agreements',
                                label: 'button__create-agreement-1',
                                value: 0,
                            });
                        }}
                        style={{ textDecoration: 'none' }}
                    >
                        <ExButton>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M7.3335 8.66671H4.00016C3.81127 8.66671 3.65294 8.60282 3.52516 8.47504C3.39738 8.34726 3.3335 8.18893 3.3335 8.00004C3.3335 7.81115 3.39738 7.65282 3.52516 7.52504C3.65294 7.39726 3.81127 7.33337 4.00016 7.33337H7.3335V4.00004C7.3335 3.81115 7.39739 3.65282 7.52516 3.52504C7.65294 3.39726 7.81127 3.33337 8.00016 3.33337C8.18905 3.33337 8.34739 3.39726 8.47516 3.52504C8.60294 3.65282 8.66683 3.81115 8.66683 4.00004V7.33337H12.0002C12.1891 7.33337 12.3474 7.39726 12.4752 7.52504C12.6029 7.65282 12.6668 7.81115 12.6668 8.00004C12.6668 8.18893 12.6029 8.34726 12.4752 8.47504C12.3474 8.60282 12.1891 8.66671 12.0002 8.66671H8.66683V12C8.66683 12.1889 8.60294 12.3473 8.47516 12.475C8.34739 12.6028 8.18905 12.6667 8.00016 12.6667C7.81127 12.6667 7.65294 12.6028 7.52516 12.475C7.39739 12.3473 7.3335 12.1889 7.3335 12V8.66671Z"
                                    fill="white"
                                />
                            </svg>
                            <p>{t('settings.commercialAgreements.sett_buttonComercialAgreements')}</p>
                        </ExButton>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default WithoutAgreement;
